import { sagas as suiteSagas } from './modules/commercial'

export default [...suiteSagas]
